import { useParams } from 'react-router-dom';
import { GreyLayout } from '@/layouts/GreyLayout';
import { useGetReportingDetail } from '@/query/queries/reporting/useGetReportingDetail';
import { Preloader } from '@/components/Preloader';
import { REPORTING_DOCS_STATUS } from '@/helpers/reporting';
import { ReportingStatus } from './ReportingStatus';
import ReportingForm from './form';

const ReportingUploadPage = () => {
  const { id } = useParams();
  const { data: detail, isLoading } = useGetReportingDetail(id);

  if (!detail || isLoading) {
    return (
      <GreyLayout>
        <Preloader style={{ height: '70vh' }} />
      </GreyLayout>
    );
  }

  return (
    <GreyLayout>
      {detail.status_documents === REPORTING_DOCS_STATUS.NEW ? (
        <ReportingForm report={detail} />
      ) : (
        <ReportingStatus report={detail} />
      )}
    </GreyLayout>
  );
};

export default ReportingUploadPage;
